const { __ } = wp.i18n
import $ from 'jquery'
import { Collapse } from 'bootstrap'

const body = document.body
const object = vnObject

import { Modal } from 'bootstrap'

const setThemeVars = () => {
  const test = __('Test JS translation', 'vn')
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('.js-fake-container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  const headerContainer = document.querySelector('header')
  if (headerContainer) {
    const headerContainerHeight = headerContainer.clientHeight
    body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  }

  const extraSpace = 15;

  body.style.setProperty(
      '--space-width',
      `${(documentWidth - mainContainerWidth) / 2 + extraSpace}px`
  );

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}

document.addEventListener('DOMContentLoaded', function(dom) {
  const tel = dom.target.querySelectorAll('[href^="tel:"]')
  if (tel.length && object.gtmPhoneClass !== '') {
    tel.forEach((el) => {
      el.classList.add(object.gtmPhoneClass)
    })
  }
  const maps = dom.target.querySelectorAll('[href*="maps"]')

  if (maps.length && object.gtmItineraryClass !== '') {
    maps.forEach((el) => {
      el.classList.add(object.gtmItineraryClass)
    })
  }
  const mails = dom.target.querySelectorAll('[href^="mailto:"]')

  if (mails.length && object.gtmMailClass !== '') {
    mails.forEach((el) => {
      el.classList.add(object.gtmMailClass)
    })
  }

  const cookies = dom.target
    .querySelector('footer li.cookies')

  if (cookies) {
    cookies.addEventListener('click', function(e) {
      e.preventDefault()
      openAxeptioCookies()
    })
  }

  const dataHrefs = dom.target.querySelectorAll('[data-href]')

  if (dataHrefs.length) {
    dataHrefs.forEach((el) => {
      el.addEventListener('click', (e) => {
        // Laisser les liens <a> fonctionner normalement
        if (e.target.closest('a, form') ) {
          return
        }

        e.preventDefault()
        window.location.href = el.dataset.href
      })
    })
  }

  $(document).on('click', '.accordion-item', function (e) {
    // On laisse Bootstrap gérer directement le clic sur le bouton
    if ($(e.target).closest('.accordion-button').length) {
      return
    }

    const collapseEl = $(this).find('.accordion-collapse')[0]

    if (!collapseEl) {
      return
    }

    const collapse = Collapse.getOrCreateInstance(collapseEl, {
      toggle: false
    })

    collapse.toggle()
  })
})